import BlogPost from "../../../../src/templates/blog-post";
import { graphql } from 'gatsby';
import * as React from 'react';
export default {
  BlogPost,
  graphql,
  React
};